import { authFetch } from '../utils/authFetch';
import { baseUrl } from '../utils/requestUrl';

export const fetchAllPatients = async (pageNumber = 1, pageSize = 10) => {
  const organizationId = JSON.parse(localStorage.getItem('user')).organizations?.find((org)=>org.active === true)?.id;
  const response = await authFetch(
    `${baseUrl}/patients?organizationId=${organizationId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  );
  return response.json();
};